import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader.js';

import { isMesh } from '@spazious/dollhouse-three';

import useModelLoader from './useModelLoader.js';

/**
 * Loads a GLTF model and returns it.
 */
export const useSpace = (input: string): GLTF => {
  const gltf: GLTF = useModelLoader(input);

  ((Array.isArray(gltf) ? gltf : [gltf]) as GLTF[]).forEach(({ scene }) => {
    scene.traverse((child) => {
      child.receiveShadow = false;
      child.castShadow = false;
      if (isMesh(child)) {
        child.castShadow = true;
        child.receiveShadow = true;

        if (/navmesh/.test(child.name)) {
          child.visible = false;
        }
      }
    });
    // Do not update matrices for static resources on every frame for performance improvement
    scene.matrixAutoUpdate = false;
    scene.matrixWorldAutoUpdate = false;
  });

  return gltf;
};

export default useSpace;
